import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { authRoute } from '~/routes'
import { httpStatusRoute } from '~/routes'

import SignIn from '~/pages/SignIn';
import ForgotPassword from '~/pages/ForgotPassword';
import ResetPassword from '~/pages/ResetPassword';
import NotFoundComponent from '~/pages/NotFound/NotFound';

export const DefaultOriginRouteComponent = () => (
  <Redirect
    to={authRoute.signIn.path}
  />
);
export default function PublicRoutes() {
  return (
    <Switch>
      <Route path={authRoute.signIn.path} component={SignIn} exact />
      <Route path={authRoute.forgotPassword.path} component={ForgotPassword} exact />
      <Route path={authRoute.resetPassword.path} component={ResetPassword} exact />
      <Route path={httpStatusRoute.notFound.path} component={NotFoundComponent} exact />
      <Route component={DefaultOriginRouteComponent} />
    </Switch>
  );
}